import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import "@/assets/fonts/font.scss";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
